export function removeLeadingZero(text: string) {
  text = String(text).replace(/^0+/, '')
  return text
}

export function formatNumber(text: string) {
  return text === '00' ? '0' : text
}
